import {
   motion,
   AnimatePresence,
   useSpring,
   useTransform,
   useMotionValue,
   useAnimation,
} from "framer-motion";
import React, { useState, useRef, useEffect, useMemo } from "react";
import Link from "../components/v2/Link";
import clsx from "clsx";
import { Helmet } from "react-helmet";
import feature1 from "../images/v4/sneakPeak/images/feature1.webp";
import feature2 from "../images/v4/sneakPeak/images/feature2.webp";
import feature3 from "../images/v4/sneakPeak/images/feature3.webp";
import feature4 from "../images/v4/sneakPeak/images/feature4.webp";
import feature5 from "../images/v4/sneakPeak/images/feature5.webp";
import feature6 from "../images/v4/sneakPeak/images/feature6.webp";
import feature7 from "../images/v4/sneakPeak/images/feature7.webp";
import feature8 from "../images/v4/sneakPeak/images/feature8.webp";
import feature9 from "../images/v4/sneakPeak/images/feature9.webp";
import feature10 from "../images/v4/sneakPeak/images/feature10.webp";
import feature11 from "../images/v4/sneakPeak/images/feature11.webp";

import heroBg from "../images/v4/sneakPeak/images/heroBg.png";
import companyLogo from "../images/v4/sneakPeak/icons/companyLogo.svg";
import aiWhatsappIcon from "../images/v4/sneakPeak/icons/aiWhatsappIcon.png";

import slideIcon1 from "../images/v4/sneakPeak/icons/slideIcon1.svg";
import slideIcon2 from "../images/v4/sneakPeak/icons/slideIcon2.svg";
import slideIcon3 from "../images/v4/sneakPeak/icons/slideIcon3.svg";
import slideIcon4 from "../images/v4/sneakPeak/icons/slideIcon4.svg";
import slideIcon5 from "../images/v4/sneakPeak/icons/slideIcon5.svg";
import slideIcon6 from "../images/v4/sneakPeak/icons/slideIcon6.svg";
import slideIcon7 from "../images/v4/sneakPeak/icons/slideIcon7.svg";
import slideIcon8 from "../images/v4/sneakPeak/icons/slideIcon8.svg";
import slideIcon9 from "../images/v4/sneakPeak/icons/slideIcon9.svg";
import slideIcon10 from "../images/v4/sneakPeak/icons/slideIcon10.svg";
import slideIcon11 from "../images/v4/sneakPeak/icons/slideIcon11.svg";

import feature1Icon from "../images/v4/sneakPeak/icons/feature1Icon.svg";
import feature6Icon from "../images/v4/sneakPeak/icons/feature6Icon.svg";
import upArrow from "../images/v4/sneakPeak/icons/upArrow.svg";
import leftArrow from "../images/v4/sneakPeak/icons/leftArrow.svg";
import replayIcon from "../images/v4/sneakPeak/icons/replay.svg";

import featureImage1 from "../images/v4/sneakPeak/images/featureImage1.webp";
import featureImage2 from "../images/v4/sneakPeak/images/featureImage2.webp";
import featureImage3 from "../images/v4/sneakPeak/images/featureImage3.webp";
import featureImage4 from "../images/v4/sneakPeak/images/featureImage4.webp";
import featureImage5 from "../images/v4/sneakPeak/images/featureImage5.webp";
import featureImage6 from "../images/v4/sneakPeak/images/featureImage6.webp";
import featureImage7 from "../images/v4/sneakPeak/images/featureImage7.webp";
import featureImage8 from "../images/v4/sneakPeak/images/featureImage8.webp";
import featureImage9 from "../images/v4/sneakPeak/images/featureImage9.webp";
import featureImage10 from "../images/v4/sneakPeak/images/featureImage10.webp";
import featureImage11 from "../images/v4/sneakPeak/images/featureImage11.webp";
import bookDemoBg from "../images/v4/sneakPeak/images/bookDemoBg.png";

import LottieIcon from "../components/v4/LottieIcon";
import aiAgents from "../animations/aiAgents.json";
import aiChatbot from "../animations/aiChatbot.json";
import aiEnrichment from "../animations/aiEnrichment.json";
import aiInsights from "../animations/aiInsights.json";
import aiSignals from "../animations/aiSignals.json";
import aiVoiceToNotes from "../animations/aiVoiceToNotes.json";
import workflowAutomation from "../animations/workflowAutomation.json";
import messagingChannelIntegration from "../animations/messagingChannelIntegration.json";
import ticketingSystemForSupport from "../animations/ticketingSystemForSupport.json";
import whatsappForSales from "../animations/whatsappForSales.json";
import whatsappForMarketing from "../animations/whatsappForMarketing.json";

import SEO from "../components/SEO";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import { makeStyles } from "@material-ui/core";

import featureIcon1 from "../images/v4/sneakPeak/icons/featureIcon1.svg";
import featureIcon2 from "../images/v4/sneakPeak/icons/featureIcon2.svg";
import featureIcon3 from "../images/v4/sneakPeak/icons/featureIcon3.svg";
import featureIcon4 from "../images/v4/sneakPeak/icons/featureIcon4.svg";
import featureIcon5 from "../images/v4/sneakPeak/icons/featureIcon5.svg";
import featureIcon6 from "../images/v4/sneakPeak/icons/featureIcon6.svg";
import featureIcon7 from "../images/v4/sneakPeak/icons/featureIcon7.svg";
import featureIcon8 from "../images/v4/sneakPeak/icons/featureIcon8.svg";
import featureIcon9 from "../images/v4/sneakPeak/icons/featureIcon9.svg";
import featureIcon10 from "../images/v4/sneakPeak/icons/featureIcon10.svg";
import featureIcon11 from "../images/v4/sneakPeak/icons/featureIcon11.svg";
import featureIcon12 from "../images/v4/sneakPeak/icons/featureIcon12.svg";
import featureIcon13 from "../images/v4/sneakPeak/icons/featureIcon13.svg";
import featureIcon14 from "../images/v4/sneakPeak/icons/featureIcon14.svg";
import featureIcon15 from "../images/v4/sneakPeak/icons/featureIcon15.svg";

const styles = {
   content: {
      position: "relative",
      zIndex: 10,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "max-content",
      width: "auto",
      padding: "40px 60px",
      borderRadius: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      color: "white",
      textAlign: "center",
      backdropFilter: "blur(40px) saturate(1)",
      background: "rgba(1, 28, 51, 0.50)",
   },
   logoContainer: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "32px",
   },
   logo: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
   },
   logoInner: {},
   logoText: {
      fontSize: "24px",
      fontWeight: 600,
      letterSpacing: "-0.5px",
   },
   title: {},
   titleLast: {
      marginBottom: "48px",
   },
   button: {
      padding: "8px 32px",
   },
   mainCenterCard: {
      border: "1px solid rgb(121, 129, 138, 0.2)",
   },
   imageCard: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "16px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
   },
   header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
   },
};

const sectionStyles = makeStyles({
   "@keyframes shimmer": {
      "0%": { left: "-180%" },
      "30%": { left: "-180%" },
      "100%": { left: "180%" },
   },
   mainCenterCard: {
      overflow: "hidden",
      "&::after": {
         content: '""',
         position: "absolute",
         top: 0,
         left: 0,
         width: "70%",
         height: "100%",
         background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)",
         transform: "skewX(-35deg)",
         pointerEvents: "none",
         animation: "$shimmer 3s ease-in-out infinite",
         animationDelay: "2s",
      },
   },
   commonHeroSection: {
      position: "relative",
   },
   heroSection: {
      paddingTop: "120px",
      position: "relative",
      "@media only screen and (max-width: 600px)": {
         paddingTop: "0",
         paddingBottom: "0",
      },
   },
   heroSectionContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      margin: "0 auto",
      gap: "24px",
      textAlign: "center",
      "& h1": {
         width: "70%",

         "@media only screen and (max-width: 600px)": {
            width: "100%",
            marginBottom: "12px",
         },
      },
      "& p": {
         width: "70%",
         "@media only screen and (max-width: 600px)": {
            width: "100%",
         },
      },
      "& span": {
         background: "linear-gradient(93deg, #058ED6 4.84%, #00BFA5 99.8%)",
         WebkitBackgroundClip: "text",
         WebkitTextFillColor: "transparent",
         display: "inline-flex",
         alignItems: "baseline",
         justifyContent: "flex-start",
         gap: "5px",
         "@media only screen and (max-width: 600px)": {
            "& img": {
               height: "60px",
               width: "80px",
               objectFit: "contain",
            },
         },
      },
      "@media only screen and (max-width: 600px)": {
         gap: "0",
      },
   },
   combineSection: {
      position: "relative",
   },
   logoCard: {
      borderLeft: "1px solid #82bfd98a",
      borderTop: "1px solid #82bfd98a",
   },
   bussinessSuccesSection: {
      "& .logos-container": {
         background: "transparent",
         paddingBottom: "260px",
         "&::before,&::after": {
            display: "none",
         },

         "& .logo": {
            /* Styling */
            minWidth: "max-content",
            background: "rgba(0, 0, 0, 0.2)",
            borderRadius: "100px",
            color: "#010F1D",
            "& img": {
               width: "48px",
               height: "48px",
            },
            "@media only screen and (max-width: 600px)": {
               padding: "8px",
               margin: "0 4px",
               gap: "6px",
               "& img": {
                  width: "34px",
                  height: "34px",
               },
            },
         },
      },
      "@media only screen and (max-width: 600px)": {
         padding: "0",
         "& .logos-row": {
            padding: "2px",
            height: "60px !important",
         },
                    "& .logos-container": {
         paddingBottom: "160px",
               }
      },
   },
   cardTitleIcon: {
      display: "inline",
      verticalAlign: "end",
      marginRight: "8px",
      marginBottom: "-10px",
      "@media only screen and (max-width: 600px)": {
         width: "34px !important",
         height: "34px !important",
      },
   },
   activeCardImgWrapper: {
      "& svg": {
         borderRadius: "16px",
      },
   },
   floatImage: {
      width: "100%",
      height: "100%",
      overflow: "hidden",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      transition: "transform 500ms",
      borderRadius: "16px",
      "& img": {
         objectFit: "cover",
      },
      "&:hover": {
         transform: "scale(1.05)",
      },
      "@media only screen and (max-width: 600px)": {
         borderRadius: "10px",
      },
   },
});

let STORY_ITEMS = [
   {
      id: 1,
      description: (
         <>
            Automate lead scoring, follow-ups, record updation, and more with
            powerful AI agents.{" "}
            <span className="font-wix-bold">Execute tasks end-to-end</span>{" "}
            without manual efforts.
         </>
      ),
      lottieImage: aiAgents,
      titleIcon: slideIcon1,
      title: "AI Agents",
      link: "https://blog.peppercloud.com/10-high-impact-ai-agent-use-cases-you-can-deploy-with-pepper-cloud/",
      shadowColor: "#001D2B",
      featureIcon: feature1Icon,
      featureIconPosition:
         "absolute right-[-13%] top-1/2 -translate-y-1/2 h-[35%] w-[25%]",
      type: "lottie",
      layout: "left",
      color: "red",
      image: featureImage1,
      buttonText: "Know more",
   },
   {
      id: 2,
      description: (
         <>
            Deploy AI chatbot across WhatsApp, Facebook, and other channels.
            Respond to customer queries and FAQs instantly,{" "}
            <span className="font-wix-bold">even after business hours.</span>
         </>
      ),
      lottieImage: aiChatbot,
      titleIcon: slideIcon2,
      title: "AI Chatbot",
      link: "https://blog.peppercloud.com/assistai-chatbot-a-user-guide/",
      shadowColor: "#2B004E",
      type: "lottie",
      layout: "right",
      color: "red",
      image: featureImage2,
      buttonText: "Know more",
   },
   {
      id: 3,
      title: "AI Insights",
      description: (
         <>
            Generate chat insights, VoIP call summaries, and business record
            insights.{" "}
            <span className="font-wix-bold">Auto-extract action items</span> and
            turn them into tasks. Generate keywords and convert into tags
            easily.
         </>
      ),
      lottieImage: aiInsights,
      titleIcon: slideIcon3,
      link: "https://www.youtube.com/shorts/Ouyd7cFdaVE",
      shadowColor: "#001D2B",
      type: "lottie",
      layout: "left",
      color: "red",
      image: featureImage3,
      buttonText: "Watch video",
   },
   {
      id: 4,
      title: "AI Enrichments",
      description: (
         <>
            Get complete lead profiles in seconds. Convert incomplete lead data
            into high-value,{" "}
            <span className="font-wix-bold">sales-ready intelligence</span> by
            adding firmographic, behavioural, and contextual data.
         </>
      ),
      lottieImage: aiEnrichment,
      titleIcon: slideIcon4,
      link: "https://peppercloud.com/contact/",
      shadowColor: "#001D2B",
      type: "lottie",
      layout: "right",
      color: "red",
      image: featureImage4,
      buttonText: "Book a demo",
   },
   {
      id: 5,
      title: "AI Signals",
      description: (
         <>
            Auto-analyse conversations, emails, and past activity to{" "}
            <span className="font-wix-bold">predict next-best actions.</span>{" "}
            Send timely follow-ups and improve conversion at every pipeline
            stage.
         </>
      ),
      lottieImage: aiSignals,
      titleIcon: slideIcon5,
      link: "https://www.youtube.com/watch?v=DIK2vltXwCg&t=1s",
      shadowColor: "#0C3056",
      type: "lottie",
      layout: "left",
      color: "red",
      image: featureImage5,
      buttonText: "Watch video",
   },
   {
      id: 6,
      title: "AI Voice-to-notes",
      description: (
         <>
            Convert spoken words into{" "}
            <span className="font-wix-bold">structured notes and logs</span>{" "}
            with AI-powered voice-to-text feature and map them with records.
            Capture meeting notes and key insights easily on the move.
         </>
      ),
      lottieImage: aiVoiceToNotes,
      titleIcon: slideIcon6,
      link: "https://peppercloud.com/contact/",
      shadowColor: "#001D2B",
      featureIcon: feature6Icon,
      featureIconPosition:
         "absolute right-[-10%] top-[10%] h-[35%] w-[25%] z-10",
      type: "lottie",
      layout: "right",
      color: "red",
      image: featureImage6,
      buttonText: "Book a demo",
   },
   {
      id: 7,
      title: "Workflow Automation",
      description: (
         <>
            Automate repetitive tasks like sending follow-ups, recording
            updates, and assigning leads through{" "}
            <span className="font-wix-bold">
               smart triggers and conditions.
            </span>{" "}
            Streamline sales, marketing, and customer service workflows easily.
         </>
      ),
      lottieImage: workflowAutomation,
      titleIcon: slideIcon7,
      link: "https://peppercloud.com/sales-crm-features/workflow-automation/",
      shadowColor: "#001D2B",
      type: "lottie",
      layout: "left",
      color: "red",
      image: featureImage7,
      buttonText: "Know more",
   },
   {
      id: 8,
      title: "Messaging Channel Integrations",
      description: (
         <>
            Seamlessly connect WhatsApp, Facebook, Instagram, WeChat, and other
            messaging channels.{" "}
            <span className="font-wix-bold">
               Access all conversations from a unified inbox.
            </span>
         </>
      ),
      lottieImage: messagingChannelIntegration,
      titleIcon: slideIcon8,
      link: "https://peppercloud.com/sales-crm-features/multichannel-integration-for-sales-marketing/#:~:text=Pepper%20Cloud%20CRM%20seamlessly%20integrates,customer%20interactions%20for%20unparalleled%20efficiency.",
      shadowColor: "#4B2B55",
      type: "lottie",
      layout: "right",
      color: "red",
      image: featureImage8,
      buttonText: "Know more",
   },
   {
      id: 9,
      title: "Ticketing System for Support",
      description: (
         <>
            Enhance customer support by automatically creating, assigning, and
            resolving the tickets. Track SLAs and{" "}
            <span className="font-wix-bold">monitor performance</span> through
            real-time dashboards.
         </>
      ),
      lottieImage: ticketingSystemForSupport,
      titleIcon: slideIcon9,
      link: "https://peppercloud.com/whatsapp-crm-for-customer-support",
      shadowColor: "#3D175C",
      type: "lottie",
      layout: "left",
      color: "red",
      image: featureImage9,
      buttonText: "Know more",
   },
   {
      id: 10,
      title: "WhatsApp for Sales",
      description: (
         <>
            Reply instantly with{" "}
            <span className="font-wix-bold">predefined message templates</span>,
            auto capture leads with WhatsApp flows, enable instant purchases
            with WhatsApp catalogs, and sell effectively.
         </>
      ),
      lottieImage: whatsappForSales,
      titleIcon: slideIcon10,
      link: "https://peppercloud.com/whatsapp-crm/",
      shadowColor: "#212B00",
      type: "lottie",
      layout: "right",
      color: "red",
      image: featureImage10,
      buttonText: "Know more",
   },
   {
      id: 11,
      title: "WhatsApp for Marketing",
      description: (
         <>
            Automate WhatsApp marketing with message templates, send WhatsApp
            broadcasts, track leads, auto-send follow-ups and{" "}
            <span className="font-wix-bold">boost real-time engagement</span>{" "}
            from within CRM.
         </>
      ),
      lottieImage: whatsappForMarketing,
      titleIcon: slideIcon10,
      link: "https://www.youtube.com/watch?v=deS13SZPaeo",
      shadowColor: "#001D2B",
      type: "lottie",
      layout: "left",
      color: "red",
      image: featureImage11,
      buttonText: "Watch video",
   },
   {
      id: 12,
      type: "image",
      layout: "right",
      image: bookDemoBg,
   },
];

const FLOATING_ELEMENTS = [
   // --- FAST / BACKGROUND LAYER (Depth 1.2) ---

   // New Card: Far Top Right
   {
      id: 9,
      src: feature1,
      alt: "Cloud Computing",
      position: { top: "-20%", right: "-5%" },
      smallDevicePositon: { bottom: "-20%", right: "-5%" },
      depth: 1,
      size: "w-[55vw] md:w-[35vw] lg:w-[25vw] xl:w-[22vw]",
      type: "image",
   },
   // New Card: Far Bottom Left
   {
      id: 10,
      src: feature2,
      alt: "Cybersecurity",
      position: { bottom: "-20%", left: "-5%" },
      smallDevicePositon: { top: "-20%", left: "-5%" },
      depth: 1.2,
      size: "w-[55vw] md:w-[35vw] lg:w-[25vw] xl:w-[22vw]",
      type: "image",
   },

   // Existing Fast Cards
   {
      id: 1, // Mid Left (Entering from left)
      src: feature3,
      alt: "Creative Space",
      position: { top: "-24%", left: "-14%" },
      smallDevicePositon: { top: "-4%", left: "-14%"},
      depth: 1.4,
      size: "w-[60vw] md:w-[40vw] lg:w-[28vw] xl:w-[25vw]",
      type: "image",
   },
   {
      id: 2, // Mid Right (Entering from right)
      src: feature10,
      alt: "Technology",
      position: { top: "38%", right: "-12%" },
      smallDevicePositon: { top: "38%", right: "-70%" },
      depth: 1,
      size: "w-[60vw] md:w-[40vw] lg:w-[28vw] xl:w-[25vw]",
      type: "image",
   },
   {
      id: 3, // Top Center (Entering from top)
      src: feature5,
      alt: "Design System",
      position: { top: "-28%", left: "35%" },
      smallDevicePositon: { top: "-22%", left: "35%" },
      depth: 1.2,
      size: "w-[55vw] md:w-[35vw] lg:w-[25vw] xl:w-[22vw]",
      type: "ui",
   },
   {
      id: 4, // Bottom Center (Entering from bottom)
      src: feature6,
      alt: "Mobile UI",
      position: { bottom: "-18%", right: "35%" },
      smallDevicePositon: { top: "-22%", right: "20%" },
      depth: 1.2,
      size: "w-[55vw] md:w-[35vw] lg:w-[25vw] xl:w-[22vw]",
      type: "image",
   },

   {
      id: 5, // Top Left Corner
      src: feature7,
      alt: "Teamwork",
      position: { top: "10%", left: "5%" },
      depth: 1.7,
      size: "w-[45vw] md:w-[30vw] lg:w-[20vw] xl:w-[18vw]",
      smallDevicePositon: { top: "30%", left: "-4%" },
      type: "image",
   },
   {
      id: 11, // Top Left Corner
      src: feature8,
      alt: "Teamwork",
      position: { top: "88%", right: "-12%" },
      smallDevicePositon: { top: "80%", right: "-6%" },
      depth: 1.3,
      size: "w-[45vw] md:w-[30vw] lg:w-[20vw] xl:w-[18vw]",
      type: "image",
   },
   {
      id: 6, // Top Right Corner
      src: feature11,
      alt: "Analytics",
      position: { top: "12%", right: "5%" },
      smallDevicePositon: { top: "13%", right: "-35%" },
      depth: 1.3,
      size: "w-[45vw] md:w-[30vw] lg:w-[20vw] xl:w-[18vw]",
      type: "image",
   },
   {
      id: 7, // Bottom Left Corner
      src: feature9,
      alt: "Nature",
      position: { bottom: "12%", left: "5%" },
      smallDevicePositon: { bottom: "16%", left: "0%" },
      depth: 1.3,
      size: "w-[45vw] md:w-[30vw] lg:w-[20vw] xl:w-[18vw]",
      type: "image",
   },
   {
      id: 8, // Bottom Right Corner
      src: feature4,
      alt: "Abstract",
      position: { bottom: "5%", right: "8%" },
      smallDevicePositon: { top: "-8%", right: "-8%" },
      depth: 1.7,
      size: "w-[45vw] md:w-[30vw] lg:w-[20vw] xl:w-[18vw]",
      type: "image",
   },
];

const getThemeStyles = (color) => {
   const styles = {
      red: "bg-rose-500/20 text-rose-200 border-rose-500/30",
      blue: "bg-blue-500/20 text-blue-200 border-blue-500/30",
      green: "bg-emerald-500/20 text-emerald-200 border-emerald-500/30",
      purple: "bg-purple-500/20 text-purple-200 border-purple-500/30",
      orange: "bg-orange-500/20 text-orange-200 border-orange-500/30",
      pink: "bg-pink-500/20 text-pink-200 border-pink-500/30",
      cyan: "bg-cyan-500/20 text-cyan-200 border-cyan-500/30",
      yellow: "bg-yellow-500/20 text-yellow-200 border-yellow-500/30",
      teal: "bg-teal-500/20 text-teal-200 border-teal-500/30",
   };
   return styles[color] || styles.blue;
};
const SneakPeak = () => {
   const [view, setView] = useState("hero");
   const [uiReady, setUiReady] = useState(false);

   useEffect(() => {
      const script = document.createElement("script");
      script.src = "/tailwind.js";
      script.async = true;
      script.onload = () => setTimeout(() => setUiReady(true), 50);
      script.onerror = () => setUiReady(true); // fallback
      document.head.appendChild(script);

      // Fallback: show after 800ms even if script doesn't fire onload
      const fallback = setTimeout(() => setUiReady(true), 800);

      return () => {
         document.head.removeChild(script);
         clearTimeout(fallback);
      };
   }, []);
   const items = STORY_ITEMS;

   return (
      <main className="w-full h-screen relative overflow-hidden bg-slate-950">
         <Helmet>
            <script src="/tailwind.js"></script>
         </Helmet>
         <SEO
            description={
               "Take a sneak peek into Pepper Cloud’s powerful Sales CRM. Explore every feature through videos and visuals in this complete product walkaround."
            }
            jsonLd={[
               {
                  "@context": "https://schema.org",
                  "@type": "Organization",
                  name: "Pepper Cloud",
                  legalName: "Pepper Cloud PTE LTD",
                  url: "https://peppercloud.com/",
                  logo: "https://peppercloud.com/icons/logo.png",
                  foundingDate: "2017",
                  address: [
                     {
                        "@type": "PostalAddress",
                        streetAddress: "#04-01/02",
                        addressLocality: "Blk 79 Ayer Rajah Crescent",
                        addressRegion: "SG",
                        postalCode: "139955",
                        addressCountry: "Singapore",
                     },
                     {
                        "@type": "PostalAddress",
                        streetAddress:
                           "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                        addressLocality: "Bengaluru",
                        addressRegion: "KA",
                        postalCode: "560095",
                        addressCountry: "India",
                     },
                  ],
                  contactPoint: {
                     "@type": "ContactPoint",
                     contactType: "customer support",
                     telephone: "+6566562616",
                     email: [
                        "sales@peppercloud.com",
                        "support@peppercloud.com",
                     ],
                  },
                  sameAs: [
                     "https://twitter.com/peppercloudpte",
                     "https://www.linkedin.com/company/peppercloud/",
                     "https://www.facebook.com/PepperCloudPteLtd",
                     "https://www.instagram.com/pepper.cloud/",
                  ],
               },
            ]}
            keywords="Pepper Cloud CRM overview,Pepper Cloud product walkthrough,CRM features in action,Sales CRM platform view,CRM tools and dashboard"
            ogData={{
               "og:image": [
                  "/meta/og/1X1/home.png",
                  "/meta/og/1024X512/home.png",
                  "/meta/og/1200X630/home.png",
               ],
            }}
            pathname={
               "https://peppercloud.com/pepper-cloud-crm-feature-walkaround/"
            }
            title={
               "Pepper Cloud Sneak Peek: Explore Our All CRM Features in Action"
            }
         />
         {/* Overlay to hide broken UI until Tailwind finishes loading */}
         <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: uiReady ? 0 : 1 }}
            transition={{ duration: 0.3 }}
            style={{
               position: "fixed",
               inset: 0,
               background: "#020617",
               zIndex: 9999,
               pointerEvents: uiReady ? "none" : "all",
            }}
         />
         <AnimatePresence>
            {view === "hero" ? (
               <motion.div
                  key="hero"
                  className="w-full h-full"
                  exit={{ opacity: 0, scale: 1.1, filter: "blur(10px)" }}
                  transition={{ duration: 0.8 }}
               >
                  <ParallaxHero onStart={() => setView("story")} />
               </motion.div>
            ) : (
               <motion.div
                  key="story"
                  className="w-full h-full"
                  initial={{ opacity: 0, filter: "blur(4px)" }}
                  animate={{ opacity: 1, filter: "blur(0px)" }}
                  exit={{ opacity: 0, filter: "blur(4px)" }}
                  transition={{ duration: 0.5,}}
               >
                  <StoryViewer
                     optimizedItems={items}
                     onBackToStart={() => setView("hero")}
                  />
               </motion.div>
            )}
         </AnimatePresence>
      </main>
   );
};

const ParallaxHero = ({ onStart }) => {
   const classes = sectionStyles();
   const containerRef = useRef(null);
   const mouseX = useMotionValue(0);
   const mouseY = useMotionValue(0);
   const [pageReady, setPageReady] = useState(false);
   const [floatingReady, setFloatingReady] = useState(false);
   useEffect(() => {
      const t1 = setTimeout(() => setPageReady(true), 20);
      const t2 = setTimeout(() => setFloatingReady(true), 20);
      return () => {
         clearTimeout(t1);
         clearTimeout(t2);
      };
   }, []);

   const handleMouseMove = (e) => {
      if (!containerRef.current) return;
      const { width, height, left, top } =
         containerRef.current.getBoundingClientRect();

      // Normalize mouse coordinates from -0.5 to 0.5 relative to the center
      const x = (e.clientX - left) / width - 0.5;
      const y = (e.clientY - top) / height - 0.5;

      mouseX.set(x);
      mouseY.set(y);
   };

   return (
      <motion.div
         initial={{ opacity: 0 }}
         animate={{ opacity: pageReady ? 1 : 0 }}
         transition={{ duration: 0.4, ease: "easeOut" }}
         ref={containerRef}
         onMouseMove={handleMouseMove}
         onClick={onStart}
         className="relative w-full h-full from-blue-900 via-teal-900 to-black overflow-hidden flex items-center justify-center bg-no-repeat bg-cover bg-center"
         style={{ backgroundImage: `url(${heroBg})` }}
      >
         {/* Background ambient glow */}
         <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/40 pointer-events-none z-0" />

         {/* Floating Elements Layer */}
         <div className="absolute inset-0 z-10 w-full h-full">
            {floatingReady &&
               FLOATING_ELEMENTS.map((el) => (
                  <FloatingCard
                     key={el.id}
                     data={el}
                     mouseX={mouseX}
                     mouseY={mouseY}
                  />
               ))}
         </div>

         {/* Center Content Card */}
         <motion.div
            className="relative z-20 md:w-auto text-center mb-[20%] md:mb-[0]"
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
         >
            <div
               className={`relative rounded-[24px] md:rounded-[40px] backdrop-blur-xl bg-black/15 pt-[60px] pb-[60px] pl-8 pr-8 md:pt-20 md:pb-20 md:pl-32 md:pr-32 mx-[20px] flex flex-col items-center ${classes.mainCenterCard}`}
               style={styles.mainCenterCard}
            >
               <div style={styles.logoContainer}>
                  <a href="/" style={{ cursor: "pointer" }}>
                     <div style={styles.logo}>
                        <div style={styles.logoInner}>
                           <img
                              src={companyLogo}
                              alt="Pepper Cloud - Best Sales CRM Software"
                           />
                        </div>
                     </div>
                  </a>
               </div>

               <div className="flex flex-col md:flex-row items-center justify-center gap-2.5 mb-[10px] md:mb-[16px]">
                  <img src={aiWhatsappIcon} style={{ height: "46px" }} />
                  <h1
                     className="font-wix-bold font-48 font-white"
                     style={{
                        ...styles.title,
                        // transform: `translate(${mousePosition.x * -8}px, ${mousePosition.y * -8}px)`,
                        transition: "transform 0.08s ease-out",
                     }}
                  >
                     AI WhatsApp CRM
                  </h1>
               </div>
               <h1
                  className="font-wix-medium font-28 font-white"
                  style={{
                     ...styles.titleLast,
                     // transform: `translate(${mousePosition.x * -8}px, ${mousePosition.y * -8}px)`,
                     transition: "transform 0.08s ease-out",
                  }}
               >
                  Built for sales and support teams
               </h1>

               <button
                  className="primaryButton font-20 font-wix-medium outline-none focus:outline-none"
                  style={{
                     ...styles.button,
                     // transform: `translate(${mousePosition.x * -5}px, ${mousePosition.y * -5}px)`,
                  }}
                  onClick={onStart}
               >
                  Next
               </button>
            </div>
         </motion.div>
      </motion.div>
   );
};

const StoryViewer = ({ optimizedItems, onBackToStart }) => {
   const classes = sectionStyles();
   const [progress, setProgress] = useState(0);
   const containerRef = useRef(null);
   const isThrottled = useRef(false);
   const progressRef = useRef(0);
   progressRef.current = progress;
   const [isMobile, setIsMobile] = useState(
      typeof window !== "undefined" && window.innerWidth <= 768,
   );
   useEffect(() => {
      const onResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
   }, []);

   const items = useMemo(
      () =>
         optimizedItems.map((item) => ({
            ...item,
            lottieImage: item.lottieImage
               ? JSON.parse(JSON.stringify(item.lottieImage))
               : null,
         })),
      [optimizedItems],
   );

   const lastSlideIndex = items.length - 1;
   const currentIndex = Math.min(Math.round(progress), lastSlideIndex);
   const isLastPage = currentIndex === lastSlideIndex;
   const slideItems = items;
   const progressPct = Math.round(
      ((progress + 1) / (lastSlideIndex + 1)) * 100,
   );

   const handleNext = () => {
      setProgress((p) => {
         const next = Number.isInteger(p) ? p + 1 : Math.ceil(p);
         return Math.min(next, lastSlideIndex);
      });
   };

   const handlePrev = () => {
      if (progressRef.current <= 0) {
         onBackToStart();
         return;
      }
      setProgress((p) => {
         const prev = Number.isInteger(p) ? p - 1 : Math.floor(p);
         return Math.max(prev, 0);
      });
   };

   const allIcons = [
      {
         img: featureIcon1,
         title: "Auto-lead capture",
         bgColor: "#CEE9FF",
      },
      {
         img: featureIcon2,
         title: "Sales pipeline management",
         bgColor: "#FFE9DA",
      },
      {
         img: featureIcon3,
         title: "WhatsApp CRM",
         bgColor: "#BEE7E7",
      },
      {
         img: featureIcon4,
         title: "Omnichannel CRM",
         bgColor: "#F1DFFF",
      },
      {
         img: featureIcon5,
         title: "Workflow automation",
         bgColor: "#FFEDD2",
      },
      {
         img: featureIcon6,
         title: "Contact management",
         bgColor: "#CEE9FF",
      },
      {
         img: featureIcon7,
         title: "Email marketing",
         bgColor: "#CEE9FF",
      },
      {
         img: featureIcon8,
         title: "Sales forecasting",
         bgColor: "#FFE9DA",
      },
      {
         img: featureIcon9,
         title: "Mobile CRM",
         bgColor: "#BEE7E7",
      },
      {
         img: featureIcon10,
         title: "Quotation generation",
         bgColor: "#BEE7E7",
      },
      {
         img: featureIcon11,
         title: "AI chatbot",
         bgColor: "#CEE9FF",
      },
      {
         img: featureIcon12,
         title: "UTM tracking",
         bgColor: "#FFE9DA",
      },
      {
         img: featureIcon13,
         title: "VOIP tool integration",
         bgColor: "#F1DFFF",
      },
      {
         img: featureIcon14,
         title: "Real-time dashboard",
         bgColor: "#FFEDD2",
      },
      {
         img: featureIcon15,
         title: "Video conferencing",
         bgColor: "#F1DFFF",
      },
   ];

   // Function to distribute icons across three tracks
   function distributeIcons(icons) {
      // Sort icons alphabetically to ensure consistent distribution
      const sortedIcons = [...icons].sort((a, b) =>
         a.title.localeCompare(b.title),
      );

      const logotrack1 = [];
      const logotrack2 = [];
      const logotrack3 = [];

      sortedIcons.forEach((icon, index) => {
         // Distribute icons based on their index
         switch (index % 3) {
            case 0:
               logotrack1.push(icon);
               break;
            case 1:
               logotrack2.push(icon);
               break;
            case 2:
               logotrack3.push(icon);
               break;
         }
      });

      return {
         logotrack1,
         logotrack2,
         logotrack3,
      };
   }
   useEffect(() => {
      // Only run when we're on the last page
      if (!isLastPage) return;

      // Small delay to ensure DOM is ready
      const timer = setTimeout(() => {
         class InfiniteScroll {
            constructor(row, speed) {
               this.row = row;
               this.track = row.querySelector(".logos-track");
               if (!this.track) return; // Safety check

               this.speed = speed;
               this.position = 0;
               this.direction = row.dataset.direction || "left";
               this.init();
            }

            init() {
               const content = this.track.innerHTML;
               this.track.innerHTML = content + content + content;

               const logos = this.track.querySelectorAll(".logo");
               if (logos.length === 0) return; // Safety check

               let totalWidth = 0;
               logos.forEach((logo) => {
                  totalWidth +=
                     logo.offsetWidth +
                     parseInt(getComputedStyle(logo).marginLeft) +
                     parseInt(getComputedStyle(logo).marginRight);
               });

               this.row.style.height = logos[0].offsetHeight + 20 + "px";

               if (this.direction === "left") {
                  this.position = 0;
               } else {
                  this.position = -this.track.offsetWidth / 3;
               }

               this.animate();
            }

            animate() {
               const animate = () => {
                  if (this.direction === "left") {
                     this.position -= this.speed;
                     const oneThirdWidth = -this.track.offsetWidth / 3;
                     if (this.position <= oneThirdWidth) {
                        this.position = 0;
                     }
                  } else {
                     this.position += this.speed;
                     if (this.position >= 0) {
                        this.position = -this.track.offsetWidth / 3;
                     }
                  }

                  this.track.style.transform = `translateX(${this.position}px)`;
                  requestAnimationFrame(animate);
               };

               requestAnimationFrame(animate);
            }
         }

         const rows = document.querySelectorAll(".logos-row");
         console.log("Found rows:", rows.length); // Debug

         rows.forEach((row) => {
            const speed = parseFloat(row.dataset.speed) || 1;
            new InfiniteScroll(row, speed);
         });
      }, 100);

      return () => clearTimeout(timer);
   }, [isLastPage]); // Add isLastPage as dependency
   // Get the distributed icons
   const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

   useEffect(() => {
      const activateThrottle = () => {
         isThrottled.current = true;
         setTimeout(() => {
            isThrottled.current = false;
         }, 1000);
      };

      const handleWheel = (e) => {
         e.preventDefault();

         // Normalize across deltaMode: 0=pixels, 1=lines(×30), 2=pages(×300)
         const multiplier =
            e.deltaMode === 1 ? 30 : e.deltaMode === 2 ? 300 : 1;
         const delta = (e.deltaY + e.deltaX) * multiplier;
         // Scale scroll speed: proportional to delta but capped so it never jumps too fast
         const step = Math.min(Math.abs(delta) * 0.003, 0.08);

         if (delta > 0) {
            setProgress((p) => Math.min(p + step, lastSlideIndex));
         } else if (delta < 0) {
            if (progressRef.current <= 0) return;
            setProgress((p) => Math.max(p - step, 0));
         }
      };

      const handleKeyDown = (e) => {
         if (e.key === "ArrowDown") {
            e.preventDefault();
            setProgress((p) => Math.min(p + 0.06, lastSlideIndex));
         } else if (e.key === "ArrowUp") {
            e.preventDefault();
            if (progressRef.current <= 0) return;
            setProgress((p) => Math.max(p - 0.06, 0));
         }
      };

      const element = containerRef.current;
      if (element) {
         element.addEventListener("wheel", handleWheel, { passive: false });
      }
      window.addEventListener("keydown", handleKeyDown);

      return () => {
         if (element) {
            element.removeEventListener("wheel", handleWheel);
         }
         window.removeEventListener("keydown", handleKeyDown);
      };
   }, [currentIndex, lastSlideIndex, onBackToStart, progress]);

   return (
      <motion.div
         ref={containerRef}
         className="relative w-full h-screen max-[1100px]:h-[calc(100vh-68px)] bg-slate-950 overflow-hidden"
      >
         {/* Dark overlay */}
         <div className="absolute inset-0 z-[1] pointer-events-none" style={{ background: "rgba(0,0,0,0.4)" }} />

         {/* Dynamic Background Blur Layer — all images stacked, crossfade via opacity */}
         <div className="absolute inset-0 pointer-events-none overflow-hidden">
            {items.map((item, i) => (
               <motion.img
                  key={item.id}
                  src={item.image}
                  alt=""
                  initial={{ opacity: i === 0 ? 1 : 0 }}
                  animate={{ opacity: i === currentIndex ? 1 : 0 }}
                  transition={{ duration: 0.8, ease: "easeInOut" }}
                  className="absolute inset-0 w-full h-full object-cover"
                  style={{ filter: "blur(10px)", transform: "scale(1.05)" }}
               />
            ))}
         </div>

         {/* Main Content Container */}
         <div
            className="absolute mx-auto overflow-visible flex items-center justify-center flex-col"
            style={{ inset: isLastPage ? "0%" : "6% 6% calc(6% + 120px) 6%" }}
         >
            {/* All slide cards — always rendered, positioned and scaled by progress */}
            {slideItems.map((item, i) => (
               <SlideCard
                  key={item.id}
                  item={item}
                  index={i}
                  progress={progress}
                  classes={classes}
                  isLast={i === lastSlideIndex}
                  isMobile={isMobile}
               >
                  {i === lastSlideIndex && (
                     <>
                        <section className={classes.commonHeroSection}>
                           <section className={classes.heroSection}>
                              <div className="container">
                                 <div className={classes.heroSectionContainer}>
                                    <motion.h1
                                       initial={{ opacity: 0, y: 30 }}
                                       animate={{ opacity: 1, y: 0 }}
                                       transition={{ duration: 0.5 }}
                                       className="font-wix-regular font-white font-20 md:text-[40px]"
                                    >
                                       Sell smarter, Support faster with
                                    </motion.h1>
                                    <motion.h1
                                       initial={{ opacity: 0, y: 30 }}
                                       animate={{ opacity: 1, y: 0 }}
                                       transition={{
                                          duration: 0.5,
                                          delay: 0.1,
                                       }}
                                       className="font-wix-bold font-white font-64 flex flex-col items-center gap-2 md:flex md:flex-row md:justify-center md:gap-2"
                                    >
                                       <LazyImage source={aiWhatsappIcon} />
                                       AI Whatsapp CRM
                                    </motion.h1>
                                 </div>
                              </div>
                           </section>
                        </section>
                        <section className={classes.combineSection}>
                           <section className={classes.bussinessSuccesSection}>
                              <section>
                                 <div className="logos-container">
                                    <div className="scroll-container">
                                       <div
                                          className="logos-row"
                                          data-direction="left"
                                          data-speed="0.8"
                                       >
                                          <div className="logos-track">
                                             {logotrack1.map((logo) => (
                                                <div
                                                   key={logo.title}
                                                   className={`${classes.logoCard} logo font-18 font-wix-medium font-white`}
                                                >
                                                   <img
                                                      alt={`${logo.title} integration`}
                                                      src={logo.img}
                                                   />
                                                   <p>{logo.title}</p>
                                                </div>
                                             ))}
                                          </div>
                                       </div>
                                       <div
                                          className="logos-row"
                                          data-direction="right"
                                          data-speed="0.8"
                                       >
                                          <div className="logos-track">
                                             {logotrack2.map((logo) => (
                                                <div
                                                   key={logo.title}
                                                   className={`${classes.logoCard} logo font-18 font-wix-medium font-white`}
                                                >
                                                   <img
                                                      alt={`${logo.title} integration`}
                                                      src={logo.img}
                                                   />
                                                   <p>{logo.title}</p>
                                                </div>
                                             ))}
                                          </div>
                                       </div>
                                       <div
                                          className="logos-row md:hidden block"
                                          data-direction="left"
                                          data-speed="0.6"
                                       >
                                          <div className="logos-track">
                                             {logotrack3.map((logo) => (
                                                <div
                                                   key={logo.title}
                                                   className={`${classes.logoCard} logo font-18 font-wix-medium font-white`}
                                                >
                                                   <img
                                                      alt={`${logo.title} integration`}
                                                      src={logo.img}
                                                   />
                                                   <p>{logo.title}</p>
                                                </div>
                                             ))}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </section>
                           </section>
                        </section>
                     </>
                  )}
               </SlideCard>
            ))}
         </div>

         {/* 3. Bottom Navigation Bar — fixed over the cards */}
         <div
            className="absolute bottom-0 left-0 right-0 z-50 w-full px-8 pb-10 pt-6 flex items-end justify-between pointer-events-none"
            style={{ background: "none" }}
         >
            <div
               style={{
                  position: "absolute",
                  bottom: "40px",
                  left: "50px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  zIndex: 200,
                  color: "white",
                  fontSize: "32px",
               }}
            >
               <div className="flex items-center justify-start md:flex hidden">
                  <a
                     href="/"
                     style={{
                        cursor: "pointer",
                        display: "flex",
                        pointerEvents: "auto",
                     }}
                  >
                     <img src={companyLogo} />
                  </a>
                  <span style={{ margin: "0 8px", opacity: 0.5 }}>|</span>
                  <span className="font-wix-medium font-20">
                     AI WhatsApp CRM
                  </span>
               </div>
            </div>
            {/* Navigation Controls */}
            <div
               style={{
                  position: "absolute",
                  bottom: isMobile ? "24px" : "40px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  pointerEvents: "auto",
                  gap: "16px",
                  zIndex: 200,
               }}
            >
               <button
                  onClick={handlePrev}
                  className="flex flex-col justify-center items-center w-[42px] h-[42px] md:w-[50px] md:h-[50px] border border-white rounded-full hover:bg-white/55 hover:text-white hover:no-underline outline-none focus:outline-none"
               >
                  <LazyImage source={leftArrow} alt="Previous" />
               </button>
               {isLastPage ? (
                  <Link
                     className="flex flex-col justify-center min-w-max items-center px-[32px] py-[8px] md:px-10 md:py-4 bg-gradient-to-r from-[#FF682A] via-[#FF7056] via-[#FF682A] to-[#FF550F] rounded-full font-inter-medium font-18 font-white hover:text-white hover:no-underline hover:animate-[anime_5s_linear_infinite]"
                     to="/contact/"
                  >
                     Book a free demo
                  </Link>
               ) : (
                  <button
                     onClick={handleNext}
                     className="flex flex-row justify-center items-center gap-2 w-[113px] h-[44px] md:w-[121px] md:h-[52px] bg-gradient-to-r from-[#FF682A] via-[#FF7056] via-[#FF682A] to-[#FF550F] rounded-full font-inter-medium font-18 px-4 font-white hover:text-white hover:no-underline hover:animate-[anime_5s_linear_infinite] outline-none focus:outline-none"
                  >
                     Next{" "}
                     <LazyImage
                        source={leftArrow}
                        alt="Previous"
                        className={"tras rotate-180"}
                     />
                  </button>
               )}
               {isLastPage && (
                  <button
                     onClick={() => setProgress(0)}
                     className="flex flex-col justify-center items-center w-[42px] h-[42px] md:w-[50px] md:h-[50px] border border-white rounded-full hover:bg-white/55 hover:text-white hover:no-underline outline-none focus:outline-none"
                  >
                     <LazyImage source={replayIcon} alt="Replay" />
                  </button>
               )}
            </div>
            {/* Progress Indicator */}
            <div className="absolute bottom-[8rem] md:bottom-[40px] left-1/2 -translate-x-1/2 md:left-auto md:right-[50px] md:translate-x-0 text-white font-20 font-wix-medium z-[200] opacity-90">
               Progress <span className="font-wix-bold">{progressPct}%</span>
            </div>
         </div>
      </motion.div>
   );
};

// --- Sub Components ---

const SlideCard = ({
   item,
   index,
   progress,
   classes,
   isLast,
   isMobile,
   children,
}) => {
   const isLeft = index % 2 === 0;
   const rel = index - progress;
   const absRel = Math.abs(rel);
   const isActive = rel === 0;
   const isLastExpanded = isLast && isActive;

   let scale, opacity, x;

   if (rel > 2) {
      scale = 0.1;
      opacity = 0;
      x = 0;
   } else if (rel >= 1) {
      // Hidden until current card is 98% gone, then start fading in
      if (rel > 1.1) {
         scale = 0.2;
         opacity = isMobile ? 0 : 0.4;
         x = 0;
      } else {
         const t = (rel - 1) / 0.1; // 1→0 as rel goes 1.1→1.0
         scale = 0.2 + 0.25 * (1 - t); // 0.2 → 0.45
         opacity = isMobile ? 0 : 0.4 + 0.2 * (1 - t); // 0.4 → 0.6
         x = 0;
      }
   } else if (rel >= 0) {
      // Incoming: grows from next-size (0.45) to full (1.0) as current exits
      scale = 0.45 + (1 - rel) * 0.55;
      opacity = isMobile ? (1 - rel) : 0.6 + (1 - rel) * 0.4;
      x = 0;
   } else if (rel >= -1) {
      scale = 1.0 + absRel;
      opacity = Math.max(0, 1.0 - absRel * 1.08); // fully gone at scale 1.5

      // 👇 only difference
      if (isMobile) {
         x = 0; // card comes from center
      } else {
         x = (isLeft ? -1 : 1) * absRel * absRel * 320;
      }
   } else {
      scale = 2.0;
      opacity = 0;

      if (isMobile) {
         x = 0;
      } else {
         x = (isLeft ? -1 : 1) * 320;
      }
   }

   if (isLastExpanded) {
      scale = 1.0;
      opacity = 1.0;
      x = 0;
   }

   if (!isMobile && scale <= 0.25) {
      opacity = 0;
   }

   const zIndex = isLastExpanded
      ? 50
      : rel < 0
      ? 25
      : rel === 0
      ? 20
      : rel <= 2
      ? Math.round(20 - rel * 5)
      : 5;

   // Fade out content before card exits (rel < 0), fade in as card enters (rel > 0)
   const metaOpacity =
      rel < 0
         ? Math.max(0, 1 + rel * 2)
         : Math.max(0, 1 - rel * 2);

   const containerStyle = isLastExpanded
      ? { left: 0, right: 0 }
      : isMobile
      ? { left: "5%", right: "5%", display: "flex", alignItems: "center" }
      : {
           [isLeft ? "left" : "right"]: 0,
           width: "45%",
           display: "flex",
           alignItems: "center",
        };

   return (
      <motion.div
         style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            ...containerStyle,
            pointerEvents: isActive ? "auto" : "none",
            zIndex,
            overflow: isLastExpanded ? "hidden" : "visible",
         }}
         transition={{ type: "tween", duration: 0.6 }}
      >
         <motion.div
            initial={{ scale, opacity, x }}
            animate={{ scale, opacity, x }}
            transition={{ type: "tween", duration: 0.6 }}
            style={{
               width: "100%",
               height: isLastExpanded ? "100%" : "auto",
               transformOrigin:
                  isMobile || isLastExpanded
                     ? "center center"
                     : isLeft
                     ? "right center"
                     : "left center",
            }}
         >
            {isLastExpanded ? (
               <div
                  style={{
                     position: "relative",
                     width: "100%",
                     height: "100%",
                     overflow: "hidden",
                  }}
               >
                  <img
                     src={item.image}
                     alt=""
                     style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                     }}
                  />
                  <motion.div
                     initial={{ opacity: 0 }}
                     animate={{ opacity: 1 }}
                     transition={{ duration: 0.6, delay: 0.3 }}
                     style={{
                        position: "relative",
                        zIndex: 1,
                        height: "100%",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                     }}
                  >
                     {children}
                  </motion.div>
               </div>
            ) : (
               <motion.div
                 initial={{ scale: 0.4 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                className="flex flex-col items-center w-full max-w-full md:max-w-3xl lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto">
                  {item.title && (
                     <div
                        className="mb-4 md:mb-6 text-center font-wix-semibold font-32 font-white"
                        style={{
                           opacity: metaOpacity,
                           pointerEvents: metaOpacity > 0 ? "auto" : "none",
                        }}
                     >
                        <LazyImage
                           source={item.titleIcon}
                           alt={item.title}
                           className={classes.cardTitleIcon}
                        />
                        {item.title}
                     </div>
                  )}
                  <div className="relative w-full">
                     <div
                        className={`overflow-hidden relative w-full shadow-2xl group ${classes.activeCardImgWrapper}`}
                        style={{ borderRadius: "16px" }}
                     >
                        {item.type === "image" ? (
                           <LazyImage source={item.image} />
                        ) : (
                           <LottieIcon
                              autoplay
                              loop
                              animationData={item.lottieImage}
                              hover={false}
                              play
                           />
                        )}
                        <div
                           className="absolute bottom-0 left-0 w-full h-1/2 pointer-events-none z-[5] rounded-[0.9rem] xl:rounded-2xl md:block hidden"
                           style={{
                              background: `linear-gradient(to top, ${
                                 item.shadowColor || "#000000"
                              } 0%, ${item.shadowColor || "#000000"} 20%, ${
                                 item.shadowColor || "#000000"
                              }CC 40%, transparent 100%)`,
                           }}
                        />
                        <p
                           className="font-wix-regular font-18 sm:font-14 font-white absolute bottom-8 left-1/2 -translate-x-1/2 w-full text-center px-0 md:px-8 z-10 md:block hidden"
                           style={{ opacity: metaOpacity }}
                        >
                           {item.description}
                        </p>
                     </div>
                     {item.featureIcon && (
                        <img
                           src={item.featureIcon}
                           className={`${item.featureIconPosition} z-10`}
                        />
                     )}
                  </div>
                  <p
                     className="font-wix-regular font-18 font-white mt-4 w-full text-center px-0 md:px-8 z-10 md:hidden"
                     style={{ opacity: metaOpacity }}
                  >
                     {item.description}
                  </p>
                  {item.link && (
                     <div
                        style={{
                           opacity: metaOpacity,
                           pointerEvents: metaOpacity > 0 ? "auto" : "none",
                        }}
                     >
                        <button
                           className="flex flex-row justify-center items-center px-5 py-2 gap-1 bg-black/30 backdrop-blur-[6px] rounded-full transition-all hover:scale-105 active:scale-95 mt-[8px] md:mt-[40px] font-wix-medium font-18 font-white outline-none focus:outline-none"
                           onClick={() => window.open(item.link, "_blank")}
                        >
                           {item.buttonText}
                        </button>
                     </div>
                  )}
               </motion.div>
            )}
         </motion.div>
      </motion.div>
   );
};

const FloatingCard = ({ data, mouseX, mouseY }) => {
   const classes = sectionStyles();
   // Extract mobile-first width from Tailwind size string as inline fallback
   // so the card is constrained even before Tailwind CDN finishes loading
   const fallbackWidth =
      (data.size?.match(/^w-\[([^\]]+)\]/) || [])[1] || "60vw";

   const [is425, setIs425] = useState(
      typeof window !== "undefined" && window.innerWidth <= 500,
   );
   useEffect(() => {
      const onResize = () => setIs425(window.innerWidth <= 500);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
   }, []);

   const activePosition =
      is425 && data.smallDevicePositon ? data.smallDevicePositon : data.position;

   const x = useTransform(
      mouseX,
      [-0.5, 0.5],
      [data.depth * 300, data.depth * -300],
   );
   const y = useTransform(
      mouseY,
      [-0.5, 0.5],
      [data.depth * 300, data.depth * -300],
   );

   // Smooth out the movement
   const springConfig = { damping: 40, stiffness: 100, mass: 1 };
   const smoothX = useSpring(x, springConfig);
   const smoothY = useSpring(y, springConfig);

   return (
      <motion.div
         initial={{ opacity: 0 }}
         animate={{ opacity: 1 }}
         transition={{ duration: 0.5, ease: "easeOut" }}
         exit={{ opacity: 0, scale: 1.1, filter: "blur(10px)" }}
         style={{
            top: activePosition.top,
            left: activePosition.left,
            right: activePosition.right,
            bottom: activePosition.bottom,
            x: smoothX,
            y: smoothY,
            maxWidth: fallbackWidth,
         }}
         className={`absolute ${data.size} z-10 pointer-events-none overflow-hidden`}
      >
         <div className={classes.floatImage}>
            <img
               src={data.src}
               alt={data.alt}
               loading="eager"
               style={{ width: "100%", height: "auto", display: "block" }}
            />
         </div>
      </motion.div>
   );
};

export default SneakPeak;
